import { Badge, Button } from 'react-bootstrap';
import { getClasses, pixelsToRem } from '@/utils';

import { FLAG_DISPLAY_MAX_COUNT } from '@/constants';
import { FlagWithTrip } from '@/models/gen/graphql';
import { SearchFlagsDocument } from '@/api/queries';
import Tooltip from '@/components/Tooltip';
import useDb from '@/hooks/useDb';
import { useMemo } from 'react';

const BADGE_REM_SIZE = pixelsToRem(4 + FLAG_DISPLAY_MAX_COUNT);
const FlagsButton = ({ flags = [], onClick, disabled }: { flags?: string[]; onClick: () => void; disabled?: boolean }): JSX.Element => {
  const { data: searchFlagsResponse } = useDb('FLAGS_BUTTON', SearchFlagsDocument, { ttl: 3 * 120 * 1000 }); // 3 hours
  const flagIdToFlag = useMemo(
    () =>
      (searchFlagsResponse?.searchFlags?.flagConnection?.edges || []).reduce(
        (acc: { [key: string]: FlagWithTrip }, { node }: { node: FlagWithTrip }): { [key: string]: FlagWithTrip } => ({
          ...acc,
          [node?.id]: node,
        }),
        {}
      ),
    [searchFlagsResponse]
  );

  return (
    <Tooltip content="Flags">
      <Button
        variant="icon"
        name="FLAGS_BUTTON"
        className={getClasses('FlagsButton', 'h-100', flags?.length > 1 ? `position-relative ` : undefined)}
        onClick={!disabled ? onClick : undefined}
        disabled={disabled}
      >
        {!flags?.length && <i className="sv sv-flag-empty" />}
        {!!flags?.length &&
          flags
            .slice(0, FLAG_DISPLAY_MAX_COUNT)
            .map(
              (flagId: string, f: number): React.JSX.Element => (
                <i
                  className={`sv sv-flag-filled {left:${pixelsToRem(f * 5)}rem;z-index:${Math.round(FLAG_DISPLAY_MAX_COUNT / (f + 1))};}`}
                  style={{ color: flagIdToFlag[flagId]?.color }}
                  key={f}
                />
              )
            )}
        {flags?.length > FLAG_DISPLAY_MAX_COUNT && (
          <Badge className={`{z-index:10;left:${BADGE_REM_SIZE}rem;}`}>+{flags?.length - FLAG_DISPLAY_MAX_COUNT}</Badge>
        )}
      </Button>
    </Tooltip>
  );
};

export default FlagsButton;
